import {RouteStateRecord} from './RouteStateRecord';
import {ROUTE_HAS_CHANGED} from './actions';

const DEFAULT_STATE = new RouteStateRecord();

export function routeStateReducer(state = DEFAULT_STATE, {type, payload} = {}) {
  switch (type){

    case ROUTE_HAS_CHANGED: {
      const {pathname} = payload;
      const currentRoute = state.currentRoute;

      return state
        .set('prevRoute', currentRoute)
        .set('currentRoute', pathname);
    }

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/state/route/routeStateReducer.js